export default "__VITE_ASSET__a1804ebe__"